import type { FunctionComponent } from 'react';
import { BreadCrumbsBar } from '../../../components/BreadCrumbs/BreadCrumbs';
import { useStatePageQuery } from '../../graphql/useStatePageQuery';

export const StatePageBreadCrumbsWithData: FunctionComponent = () => {
  const breadcrumbs = useStatePageQuery()?.data?.statePageBySlug?.breadCrumbs;
  if (!breadcrumbs) return null;

  return <BreadCrumbsBar crumbs={breadcrumbs} />;
};
